<script setup lang="ts">
import { useFormContainer } from "~/composables/useFormContainer";
import FormCard from "~/components/ui/FormCard.vue";
import Perks from "~/components/static/Perks.vue";
const locale = await getLocale("forms", "loan_protection_warning");

defineComponent({
  name: "LoanProtectionWarning",
});

defineProps({
  progress: { type: Number, required: true },
  title: { type: String, required: true },
  package: { type: String, required: true },
  rate: { type: String, required: true },
  stickyButton: { type: Boolean, default: false },
  showDisclaimer: { type: Boolean, default: false }
});

const { FormContainer } = useFormContainer();

const emit = defineEmits(["init", "submit", "decline"]);
onMounted(() => emit("init"));
</script>

<template>
  <FormContainer :progress="progress">
    <FormCard :title="title" @submit="emit('submit')" :has-sticky-button="stickyButton" header-class="pageTitle mb-4">
      <p class="text-red font-bold">{{ locale.text1 }}</p>
      <ul class="ml-4 mb-4 mt-2">
        <li>
          <strong class="text-red">- {{ locale.list1.item1 }}</strong>
        </li>
        <li>
          <strong class="text-red">- {{ locale.list1.item2 }}</strong>
        </li>
      </ul>
      <p
        v-html="locale.text2.replace('%d', formatNumber(rate, null, ' '))"
      ></p>
      <ul class="list-disc ml-4 mb-2 mt-2">
        <li v-html="locale.list2.item1" />
        <li v-html="locale.list2.item2" />
        <template v-if="package == 'G'">
          <li v-html="locale.list2.item3" />
          <li v-html="locale.list2.item4" />
        </template>
      </ul>
      <p class="my-4" v-html="locale.text3" />
      <template #link>
        <div class="text-center text-gray-700 text-sm my-4">
          <button class="underline inline" data-testid="decline" @click.prevent="emit('decline')">
            {{ locale.proceed_without_protection }}
          </button>
        </div>
        <div class="spacer h-6" />
      </template>
    </FormCard>
    <template v-if="showDisclaimer" #bottom-out>
      <p class="italic px-4">{{ locale.disclaimer }}</p>
    </template>
  </FormContainer>
  <Perks />
</template>

<style scoped></style>
